import VerifiedIcon from "@mui/icons-material/Verified";
import italy from "../../../img/Italy.jpg";
import BlackForest from "../../../img/BlackForest.jpg";
import Hollywood from "../../../img/HollyWood.jpg";
import RedRock from "../../../img/RedRock.jpg";

const TourObjects = [
   {
      img: Hollywood,
      title: "Hollywood Hills View, Los Angeles, USA",
      text: "With sweeping views of Los Angeles, the Hollywood Hills embody natural beauty. Our organic product, rich in Omega-3, brings that same purity and vitality to your health, naturally supporting your well-being.",
   },
   {
      img: RedRock,
      title: "Red Rock Trail, Arizona, USA",
      text: "The Red Rock Trail’s stunning desert vistas reflect the purity of nature. Our organic product, packed with Omega-3, mirrors this natural beauty, offering a healthy, wholesome experience straight from the earth.",
   },
   {
      img: BlackForest,
      title: "Black Forest Trail, Bavaria, Germany",
      text: "The Black Forest Trail offers serene landscapes, untouched by time. Our organic product, enriched with Omega-3, mirrors this purity, supporting your health with nature’s finest ingredients.",
   },
   {
      img: italy,
      title: "Amalfi Coast Views, Italy",
      text: "The Amalfi Coast’s breathtaking beauty mirrors our organic product, naturally rich in Omega-3. Experience the vitality of nature in every serving, supporting your health with the best ingredients Italy has to offer.",
   },
   {
      img: RedRock,
      title: "Red Rock Trail, Arizona, USA",
      text: "The Red Rock Trail’s stunning desert vistas reflect the purity of nature. Our organic product, packed with Omega-3, mirrors this natural beauty, offering a healthy, wholesome experience straight from the earth.",
   },
   {
      img: italy,
      title: "Amalfi Coast Views, Georgia",
      text: "The Amalfi Coast’s breathtaking beauty mirrors our organic product, naturally rich in Omega-3. Experience the vitality of nature in every serving, supporting your health with the best ingredients Italy has to offer.",
   },
];

export default TourObjects;
